// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4t-2";
export var blackBorderOnHover = "_4t-7";
export var cell = "_4t-6";
export var cellContainer = "_4t-3";
export var checked = "_4t-8";
export var disabled = "_4t-5";
export var featuredIconCellContainer = "_4t-9";
export var featuredIconTextContainer = "_4t-b";
export var featuredIconWrapper = "_4t-a";
export var noBorder = "_4t-c";
export var orangeSelectedRow = "_d2-3";
export var overflowableText = "_4t-0";
export var overflowableTextContainer = "_4t-1";
export var row = "_4s-0";
export var rowCheckboxCell = "_4t-4";
export var selectableTable = "_d2-2";